module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-lab-thumbnail-fd9d35f8dc9c14ec4a60255c8c0ecb71.png";